import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { RouteCDNModel } from '../../../models/detail.model'
import { IProps } from '@/components/NioMap/index.model'
import { drawWishPower } from '../../chargerMap/mapUtils'
import { MapViewMode } from '../../../contract/map'
/**
 * 心愿站渲染功能模块
 */
export default defineComponent({
  name: 'wish-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    cdnUrl: {
      type: RouteCDNModel,
      default: null,
    },
    settings: {
      // 地图设置
      type: Object as PropType<IProps>,
      default: {} as IProps,
    },
  },

  setup: (props) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const zoomLevel = ref<number>(0)

    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const WISH_POWER_MAX_ZOOM = 13
    const BASE_SIZE = componentsConfig?.wishpower?.properties?.base_size

    /**
     * 打开心愿站
     */
    const openWishPower = () => {
      mapContextRef.value?.setMaxZoom(WISH_POWER_MAX_ZOOM)
      if (zoomLevel.value == 0) {
        zoomLevel.value = props.settings.minZoom! // 会触发zoomLevel.value的监听从而渲染心愿站
      }
    }

    /**
     *
     * @param zoomLevel
     */
    const renewPowerByMapLevel = (zoomLevel: number) => {
      // 排序
      const sortLevel: number[] = [
        zoomLevel,
        ...componentsConfig.wishpower.properties.map_level,
      ].sort(function (a, b) {
        return a - b
      })
      const level = sortLevel.indexOf(zoomLevel)
      renewWishPower(
        level,
        componentsConfig.wishpower.properties.cluster_radius[level],
        componentsConfig.wishpower.properties.min[level],
        componentsConfig.wishpower.properties.max[level]
      )
    }

    /**
     * 通过zoomLevel不同 调整wishpower点的大小
     * @param level 缩放所处的level
     * @param clusterRadius 聚合半径
     * @param minZoom 设定缩放比例的最小值
     * @param maxZoom 设定缩放比例的最大值
     * @param baseSize 基础大小
     */
    const renewWishPower = (level: number, clusterRadius: number, min: number, max: number) => {
      if (props.componentStore.wishPowerResources?.length) {
        const w =
          BASE_SIZE > 0
            ? ((zoomLevel.value - props.settings.minZoom!) /
                (WISH_POWER_MAX_ZOOM - props.settings.minZoom!)) *
                BASE_SIZE *
                componentsConfig.wishpower.properties.zoom_rate +
              BASE_SIZE
            : componentsConfig.wishpower.properties.size[level]
        drawWishPower(mapContextRef.value!, props.componentStore.wishPowerResources, 'wishPower', {
          size: w,
          gridSize: clusterRadius,
          min,
          max,
        })
      }
    }

    // ------------暴露出去的方法--------------
    const zoomEnd = async () => {
      zoomLevel.value = mapInstance.value?.getZoom()
    }

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', zoomEnd, false)
    }

    onUnmounted(() => {
      mapContextRef.value?.clearWishPowerLayer()
    })

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = () => {
      initEventListener()
      openWishPower()
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
        }
      },
      {
        immediate: true,
      }
    )

    watch(
      () => zoomLevel.value,
      () => {
        renewPowerByMapLevel(zoomLevel.value)
      },
      {
        immediate: true,
      }
    )

    return () => {}
  },
})
